module.exports = __webpack_public_path__ + "static/media/apurva_deshpande.2be59d3b.png";